import React from 'react';
import './AddTodo.css'

class AddTodo extends React.Component{

    state = {
        title : ''
    }

    // Méthodes :
    onChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        this.props.addTodo(this.state.title);
        this.setState({title: ''});
    }

    render(){
        return(
            <div className="conteneur_addTodo" onSubmit={this.onSubmit}>
                <form>
                    <input type="text" name="title" value={this.state.title} placeholder="Saisir une nouvelle tâche ICI" onChange={this.onChange} />
                    <input type="submit" value="Ajouter tâche" />
                </form>
            </div>
        );
    }

}

export default AddTodo;